module.exports = __webpack_public_path__ + "img/flecha.97ada6d0.png";